var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1292 12.3329V5.6671C17.1292 4.83097 16.6879 4.06452 15.9679 3.65806L10.1614 0.313548C9.80142 0.104516 9.40658 0 9.00013 0C8.59367 0 8.19884 0.104516 7.83884 0.313548L2.03238 3.64645C1.31238 4.06452 0.871094 4.83097 0.871094 5.6671V12.3329C0.871094 13.169 1.31238 13.9355 2.03238 14.3419L7.83884 17.6865C8.19884 17.8955 8.59367 18 9.00013 18C9.40658 18 9.80142 17.8955 10.1614 17.6865L15.9679 14.3419C16.6879 13.9355 17.1292 13.169 17.1292 12.3329ZM7.83884 15.0039L3.19367 12.3329V6.95613L7.83884 9.66193V15.0039ZM9.00013 7.6529L4.40142 4.97032L9.00013 2.32258L13.5988 4.97032L9.00013 7.6529ZM14.8066 12.3329L10.1614 15.0039V9.66193L14.8066 6.95613V12.3329Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCube);
export default __webpack_public_path__ + "static/media/cube.1120b6c2e0541595e2ab4c378b80a678.svg";
export { ForwardRef as ReactComponent };